import { render, staticRenderFns } from "./BaseMesh.vue?vue&type=template&id=682a2c79&scoped=true&"
import script from "./BaseMesh.vue?vue&type=script&lang=ts&"
export * from "./BaseMesh.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "682a2c79",
  null
  
)

export default component.exports